export const STYLE_LIST_PROP = ['neutral', 'inverse'];

export const STYLE_CLASSES = {
    neutral: 'eds-link--neutral',
    inverse: 'eds-link--inverse',
    disabled: 'eds-link--disabled',
};
